import { create } from "zustand";
import { api } from "../lib/api";

export type User = {
  id: string;
  email: string;
  username: string;
  role: string;
  kyc_status: string;
  onboarding_completed: number;
  referral_code: string;
  is_demo: number;
  display_name?: string;
};

type AuthState = {
  user: User | null;
  loading: boolean;
  refresh: () => Promise<void>;
  logout: () => Promise<void>;
  setUser: (user: User | null) => void;
};

export const useAuth = create<AuthState>((set) => ({
  user: null,
  loading: true,
  setUser: (user) => set({ user, loading: false }),
  refresh: async () => {
    try {
      const data = await api<{ user: User }>("/auth/me");
      set({ user: data.user, loading: false });
    } catch {
      set({ user: null, loading: false });
    }
  },
  logout: async () => {
    await api("/auth/logout", { method: "POST" }).catch(() => undefined);
    set({ user: null });
  },
}));
